// eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference path="../dist/gui.d.ts" />

export default class TestAudio {

    public constructor(app: vf.Application, uiStage: vf.gui.Stage) {
        this.onLoad(app, uiStage)
    }

    private onLoad(app: vf.Application, uiStage: vf.gui.Stage) {

        /** audio */
        const a = new vf.gui.Audio();
        const b = new vf.gui.Audio();
        const c = new vf.gui.Audio();
        const d = new vf.gui.Audio();
        const e = new vf.gui.Audio();
        b.src = "https://s.vipkidstatic.com/fe-static/learning-stages/assets/great-20191221.mp3";
        c.src = "https://s.vipkidstatic.com/fe-static/learning-stages/assets/final-good-20191221.mp3";
        d.src = "https://s.vipkidstatic.com/fe-static/learning-stages/assets/final-good-20191221.mp3";
        e.src = "https://s.vipkidstatic.com/fe-static/learning-stages/assets/final-good-20191221.mp3";

        uiStage.addChild(a);
        uiStage.addChild(b);
        uiStage.addChild(c);
        uiStage.addChild(d);
        uiStage.addChild(e);

        a.loop = false;
        a.autoplay = true;
        a.src = "https://s.vipkidstatic.com/fe-static/learning-stages/assets/great-20191221.mp3";

        a.on("ended", () => {
            console.log("a play ended",);
            //  a.dispose();
        });
        b.on("ended", () => {
            console.log("b play ended",);
            //  a.dispose();
        });
        c.on("ended", () => {
            console.log("c play ended",);
            //  a.dispose();
        });
        d.on("ended", () => {
            console.log("d play ended",);
            //  a.dispose();
        });
        a.interactabled = true;
        a.on("canplaythrough", () => {
            console.log("im ready");
            // a.play();
        })
        setTimeout(() => {
            a.stop();
        }, 2000);

        /** 基础文本展示 */
        const basicText = new vf.gui.Label();
        basicText.style.left = 15;
        basicText.style.top = 50;
        basicText.style.color = 0xffffff;
        basicText.text = "点击我播放";
        basicText.interactabled = true;

        const t1 = new vf.gui.Label();
        t1.style.left = 25;
        t1.style.top = 100;
        t1.style.color = 0xffffff;
        t1.text = "t1";
        t1.interactabled = true;
        const t2 = new vf.gui.Label();
        t2.style.left = 25;
        t2.style.top = 150;
        t2.style.color = 0xffffff;
        t2.text = "t2";
        t2.interactabled = true;
        const t3 = new vf.gui.Label();
        t3.style.left = 25;
        t3.style.top = 200;
        t3.style.color = 0xffffff;
        t3.text = "t3";
        t3.interactabled = true;
        const t4 = new vf.gui.Label();
        t4.style.left = 25;
        t4.style.top = 250;
        t4.style.color = 0xffffff;
        t4.text = "t4";
        t4.interactabled = true;

        uiStage.addChild(basicText);
        uiStage.addChild(t1);
        uiStage.addChild(t2);
        uiStage.addChild(t3);
        uiStage.addChild(t4);

        basicText.on('down', () => {

            a.play();
        })
        t1.on('down', () => {
            console.log("t1");
            b.play();
        })
        t2.on('down', () => {
            console.log("t2");
            c.play();
        })
        t3.on('down', () => {
            console.log("t3");
            d.play();
        })
        t4.on('down', () => {
            console.log("t4");
            e.play();
        })



        this.getButton('设置/取消src', () => {

            if (b.src !== "") {

                b.src = "";
            } else {
                b.src = "https://s.vipkidstatic.com/fe-static/learning-stages/assets/great-20191221.mp3";
            }

        }, uiStage, 500, 0);



        this.getButton('设置/取消autoplay', () => {

            if (b.autoplay !== false) {

                b.autoplay = false;
            } else {
                b.autoplay = true;
            }

        }, uiStage, 500, 0);



        this.getButton('设置/取消loop', () => {

            if (b.loop !== true) {
                b.loop = true;
            } else {
                b.loop = false;
            }

        }, uiStage, 500, 0);



        this.getButton('设置/取消playbackRate', () => {

            if (b.playbackRate !== 0) {
                b.playbackRate = 0;
            } else {
                b.playbackRate = 1;
            }

        }, uiStage, 500, 0);



        this.getButton('设置/取消volume', () => {

            if (b.volume !== 0) {
                b.volume = 0;
            } else {
                b.volume = 1;
            }

        }, uiStage, 500, 0);


        let b10: boolean = false;
        let btn10 = this.getButton('设置/取消play事件', () => {

            if (!b10) {

                b10 = true;
                b.off("play", hoverFun10);
            } else {
                b10 = false;
                b.on("play", hoverFun10);
            }
        }, uiStage, 500, 0);
        function hoverFun10() {
            console.log("play");
        }



        let b11: boolean = false;
        let btn11 = this.getButton('设置/取消canplaythrough事件', () => {

            if (!b11) {

                b11 = true;
                b.off("canplaythrough", hoverFun11);
            } else {
                b11 = false;
                b.on("canplaythrough", hoverFun11);
            }
        }, uiStage, 500, 0);
        function hoverFun11() {
            console.log("canplaythrough");
        }



        let b12: boolean = false;
        let btn12 = this.getButton('设置/取消pause事件', () => {

            if (!b12) {

                b12 = true;
                b.off("pause", hoverFun12);
            } else {
                b12 = false;
                b.on("pause", hoverFun12);
            }
        }, uiStage, 500, 0);
        function hoverFun12() {
            console.log("pause");
        }


        let b13: boolean = false;
        let btn13 = this.getButton('设置/取消timeupdate事件', () => {

            if (!b13) {

                b13 = true;
                b.off("timeupdate", hoverFun13);
            } else {
                b13 = false;
                b.on("timeupdate", hoverFun13);
            }
        }, uiStage, 500, 0);
        function hoverFun13() {
            console.log("timeupdate");
        }




        let b14: boolean = false;
        let btn14 = this.getButton('设置/取消ended事件', () => {

            if (!b14) {

                b14 = true;
                b.off("ended", hoverFun14);
            } else {
                b14 = false;
                b.on("ended", hoverFun14);
            }
        }, uiStage, 500, 0);
        function hoverFun14() {
            console.log("ended");
        }



        let b15: boolean = false;
        let btn15 = this.getButton('设置/取消ended事件', () => {

            if (!b15) {

                b15 = true;
                b.off("ended", hoverFun15);
            } else {
                b15 = false;
                b.on("ended", hoverFun15);
            }
        }, uiStage, 500, 0);
        function hoverFun15() {
            console.log("ended");
        }



        let b16: boolean = false;
        let btn16 = this.getButton('设置/取消dispose事件', () => {

            if (!b16) {

                b16 = true;
                b.off("dispose", hoverFun16);
            } else {
                b16 = false;
                b.on("dispose", hoverFun16);
            }
        }, uiStage, 500, 0);
        function hoverFun16() {
            console.log("dispose");
        }



















    }

    private posY = 15;
    private getButton(title: string, clickFun: Function, target: any, x: number, y: number) {
        const button = new vf.gui.Label;
        button.style.fontSize = 30;
        button.style.fontFamily = 'PingFang-SC-Medium,PingFang-S';
        button.style.fontWeight = 500;
        button.style.color = 0xffffff;
        button.style.lineHeight = 45;
        button.text = title;
        button.interactabled = true;
        button.x = x;
        button.y = this.posY;
        button.on(vf.gui.Interaction.TouchMouseEvent.onClick, clickFun);
        target.addChild(button);
        this.posY = this.posY + 30 + y;

        return button;
    }

}

